/**
 * RecruiterBadge — small "who's assigned" initials chip for list rows and
 * detail headers. Same shape as the Kanban card's owner avatar (single
 * brand-blue circle, `initials()` from lib.ts) so assignment reads
 * consistently everywhere it appears. Unassigned reads amber, matching
 * OwnerSelect's "unrouted leads stand out" convention.
 */
import { useTeam, initials } from '../lib';

interface Props {
  ownerId: string | null | undefined;
  className?: string;
}

export default function RecruiterBadge({ ownerId, className = '' }: Props) {
  const { byId } = useTeam();

  if (!ownerId) {
    return (
      <span
        title="Unassigned"
        aria-label="Unassigned recruiter"
        className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full border border-amber-300 text-[10px] font-medium text-amber-700 dark:border-amber-700 dark:text-amber-400 ${className}`}
      >
        &ndash;
      </span>
    );
  }

  const name = byId.get(ownerId)?.name;
  return (
    <span
      title={name || 'Assigned'}
      aria-label={`Assigned recruiter: ${name || 'unknown'}`}
      className={`flex h-6 w-6 flex-shrink-0 items-center justify-center rounded-full bg-primary-100 text-[10px] font-medium text-primary-700 dark:bg-primary-900/40 dark:text-primary-300 ${className}`}
    >
      {initials(name)}
    </span>
  );
}
